import { AccordionDetails, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { UseSetLenguajePorPais } from "../../hooks/UseSetLenguajePorPais";
import IndicadorCheckbox from "./IndicadorCheckbox";
import SelectButtons from "./SelectButtons";
import {
  iObjetivoAprendizaje,
  SelectedIndicator,
} from "../../interfaces/ObjetivosAprendizaje/iObjetivosAprendizaje";
import { Dispatch, FC, SetStateAction } from "react";
import { useAuthContext } from "../../hooks/Auth";

interface Props {
  selectedIndicators: SelectedIndicator;
  handleIndicatorSelect: (idObjetivo: string, indicador: string) => void;
  handleToggleAllIndicators: (
    idObjetivo: string,
    allIndicators: string[]
  ) => void;
  objetivo: iObjetivoAprendizaje;
  allSelected: boolean;
  handleRemoveObjectiveFromProject: (objetivo: iObjetivoAprendizaje) => void;
  handleAddObjectiveToProject: (objetivo: iObjetivoAprendizaje) => void;
  hasSelectedIndicator: boolean;
  setSelectedIndicators: Dispatch<SetStateAction<SelectedIndicator>>;
  color: string;
}

const ObjectiveDetails: FC<Props> = ({
  handleAddObjectiveToProject,
  handleIndicatorSelect,
  handleRemoveObjectiveFromProject,
  handleToggleAllIndicators,
  hasSelectedIndicator,
  objetivo,
  allSelected,
  selectedIndicators,
  setSelectedIndicators,
  color
}) => {
  const { t } = useTranslation();
  UseSetLenguajePorPais();

  const { user } = useAuthContext();
  const IS_FROM_URUGUAY = user?.pais === "UY";

  const indicadores = Array.isArray((objetivo as any).indicadores)
    ? (objetivo as any).indicadores
    : [];

  return (
    <AccordionDetails>
      {Array.isArray(objetivo.indicadores) && (
        <>
          <Typography
            sx={{
              fontFamily: "Montserrat",
              color,
              fontSize: "1rem",
              fontWeight: "bold",
              textAlign: "center",
              mb: 2,
            }}
          >
            {IS_FROM_URUGUAY ? "Criterios de logro" : t("indicadores")}
          </Typography>

          {indicadores.map((indicador: string, index: number) => (

            <IndicadorCheckbox
              key={index}
              objetivo={objetivo}
              indicador={indicador}
              handleIndicatorSelect={handleIndicatorSelect}
              selectedIndicators={selectedIndicators}
              setSelectedIndicators={setSelectedIndicators}
              color={color}
            />

          ))}
        </>
      )}

     
      <SelectButtons
        handleAddObjectiveToProject={handleAddObjectiveToProject}
        handleToggleAllIndicators={handleToggleAllIndicators}
        handleRemoveObjectiveFromProject={handleRemoveObjectiveFromProject}
        hasSelectedIndicator={hasSelectedIndicator}
        objetivo={objetivo}
        allSelected={allSelected}
        setSelectedIndicators={setSelectedIndicators}
        color={color}
      />
    </AccordionDetails>
  );
};

export default ObjectiveDetails;
